var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{attrs:{"variant":_vm.status.variant}},[_vm._v("\n  "+_vm._s(_vm.status.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }